import { MILLISECONDS_PER_DAY } from "@/constants/time.constants";

const DAY_IN_MILLISECONDS = MILLISECONDS_PER_DAY;
const DAYS_IN_WEEK = 7;

type UseDateArgs = {
  targetDate: Date;
};

export function useDate({ targetDate }: UseDateArgs) {
  const currentDate = new Date();

  const delta = Math.round(
    (currentDate.getTime() - targetDate.getTime()) / DAY_IN_MILLISECONDS
  );

  // Only display the date when it's less or eq to one week.
  const displayRelativeDay = Math.abs(delta) <= DAYS_IN_WEEK;

  return {
    displayRelativeDay,
  };
}
